import { TMapBounds } from '../../types/mapBounds';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EMapBoundsActionType } from './types';

export const changeBounds = actionGenerator<EMapBoundsActionType.Changed, TMapBounds>(EMapBoundsActionType.Changed);
